import RestrictMesh from "../resources/restrict-mesh";

class RestrictVisibility extends RestrictMesh {
    constructor() {
        super();
    }
}

export default RestrictVisibility;